import React, { useContext } from 'react';
import { ContextUserProfile } from '../../../contexts/UserProfileContext';
import { SkeletonProps, Typography, TypographyProps } from '@mui/material';
import { capitalize } from '../../../utils/usefulFunctions';
import LoadingPlaceholder from '../../../muiComponents/LoadingPlaceholder';

interface SectionTitleProps {
    title: string;
    variant?: TypographyProps['variant'];
    className?: string;
    loading?: boolean;
    loadingProps?: SkeletonProps;
}

const SectionTitle: React.FC<SectionTitleProps> = ({
    title,
    variant = 'h1',
    className = '',
    loading = false,
    loadingProps,
}) => {
    const { translate } = useContext(ContextUserProfile);

    return (
        <>
            {loading ? (
                <LoadingPlaceholder variant='text' {...loadingProps} />
            ) : (
                <Typography variant={variant} className={className}>
                    {capitalize(translate(title))}
                </Typography>
            )}
        </>
    );
};

export default SectionTitle;
